// @flow
import React from 'react';
import { RichText } from 'prismic-reactjs';
import { Client } from '../prismic-configuration';
import { PageWrapper } from '../components/base';
import { PrismicAbout } from '../types/prismic';
// import useScrollPosition from '../helpers/useScrollPosition';
import AnimatingLineOne from '../components/about/AnimatingLineOne';
import AnimatingLineTwo from '../components/about/AnimatingLineTwo';
import AnimatingLineThree from '../components/about/AnimatingLineThree';
import AnimatingLineFour from '../components/about/AnimatingLineFour';
import AnimatingLineFive from '../components/about/AnimatingLineFive';
import styles from '../styles/pages/about.module.sass';

interface Props {
  doc: PrismicAbout;
}

const AboutPage = ({ doc }: Props) => {
  const {
    first_label,
    first_body,
    first_image,
    second_body,
    third_label,
    third_header,
    third_image,
    third_body,
    fourth_header,
    fourth_body,
    fourth_image,
    fifth_label,
    fifth_body,
    sixth_label,
    sixth_body,
  } = doc.data;
  // let containerRef: HTMLDivElement = null;
  // const scrollPosition = useScrollPosition();
  // const [scrollPercentage, setScrollPercentage] = useState(0);

  // const handleContainerRef = (element) => {
  //   containerRef = element;
  // };

  // useEffect(() => {
  //   if (!containerRef) return;
  //   const rect = containerRef.getBoundingClientRect();
  //   let percentage = -rect.top / (rect.height - window.innerHeight);
  //   if (percentage <= 0) percentage = 0;
  //   if (percentage > 1) percentage = 1;
  //   setScrollPercentage(percentage);
  // }, [scrollPosition]);

  // const progressOne = scrollPercentage > 1 / 5 ? 1 : scrollPercentage * 5;

  return (
    <PageWrapper title="About" containerClass="bg-rust">
      <section className="bg-rust full-width">
        <section className="bg-rust inner-width inner-width-padding column center">
          <div className={styles.container}>
            <div className={`${styles.section} ${styles.one}`}>
              <div className={styles.inner}>
                <AnimatingLineOne />
                <div className={styles.headline}>
                  <div className={styles.label}>
                    <p>{first_label}</p>
                  </div>
                  <div className={styles.header}>
                    <RichText render={first_body} />
                  </div>
                </div>
                <div className={styles.post}>
                  <img src={first_image.url} alt={first_image.alt} />
                </div>
              </div>
            </div>
            <div className={`${styles.section} ${styles.two}`}>
              <div className={styles.inner}>
                <AnimatingLineTwo />
                <div className={styles.copy}>
                  <RichText render={second_body} />
                </div>
                <div className={styles.headline}>
                  <div className={styles.label}>
                    <p>{third_label}</p>
                  </div>
                  <div className={styles.header}>
                    <RichText render={third_header} />
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles.section} ${styles.three}`}>
              <div className={styles.inner}>
                <AnimatingLineThree />
                <div className={styles.panorama}>
                  <img src={third_image.url} alt={third_image.alt} />
                </div>
                <div className={styles.copy}>
                  <RichText render={third_body} />
                </div>
              </div>
            </div>
            <div className={`${styles.section} ${styles.four}`}>
              <div className={styles.inner}>
                <AnimatingLineFour />
                <div className={styles.headline}>
                  <div className={styles.header}>
                    <RichText render={fourth_header} />
                  </div>
                  <div className={styles.copy}>
                    <RichText render={fourth_body} />
                  </div>
                </div>
                <div className={styles.image}>
                  <img src={fourth_image.url} alt={fourth_image.alt} />
                </div>
              </div>
            </div>
            <div className={`${styles.section} ${styles.five}`}>
              <div className={styles.inner}>
                <AnimatingLineFive />
                <div className={styles.headline}>
                  <div className={styles.label}>
                    <p>{fifth_label}</p>
                  </div>
                  <div className={styles.header}>
                    <RichText render={fifth_body} />
                  </div>
                </div>
                <div className={styles.outro}>
                  <div className={styles.label}>
                    <p>{sixth_label}</p>
                  </div>
                  <div className={styles.header}>
                    <RichText render={sixth_body} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </PageWrapper>
  );
};

export async function getServerSideProps() {
  const client = Client();
  const doc = await client.getSingle('about', {});

  return {
    props: {
      doc,
    },
  };
}

export default AboutPage;
